import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import restApi from '../../api'
import BasicFrame from '../layout/BasicFrame'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { productConfig } from '../../config/config-service'

function MemberGetAppPage (props) {
  const appleStoreImage = 'https://s3-us-west-2.amazonaws.com/ejenta-images/ios-app-store-link.png'
  const androidStoreImage = 'https://s3-us-west-2.amazonaws.com/ejenta-images/google-play-link.png'
  const [appleLinkHelpText, setAppleLinkHelpText] = useState('')
  const [appleLink, setAppleLink] = useState('')
  const [androidLinkHelpText, setAndroidLinkHelpText] = useState('')
  const [androidLink, setAndroidLink] = useState('')
  const [informationText, setInformationText] = useState('')

  useEffect(() => {
    const config = productConfig().mobileApp
    setAppleLink(config.appleLink)
    setAppleLinkHelpText(config.appleLinkHelpText)
    setAndroidLink(config.androidLink)
    setAndroidLinkHelpText(config.androidLinkHelpText)
    setInformationText(config.informationText)
  }, [])

  const renderDownloadApp = () => {
    const hasMobileApp = appleLink && androidLink

    return (
      <BasicFrame>
        <Box sx={{ alignItems: 'center', textAlign: 'center', width: '100vw' }}>
          <Grid container spacing={2}>
            <Grid item xs={2} />
            <Grid item xs={8}>
              <Card data-testid='member-page__card'>
                <CardContent>
                  <Typography variant='h5' gutterBottom>Welcome, member!</Typography>
                  <Typography variant='body1' data-testid='member-page__information'>{informationText}</Typography>
                  <br />
                  {hasMobileApp &&
                    <div className='login-form__app-links'>
                      <a className='appLink' href={appleLink} target='_blank' rel='noreferrer' data-testid='member-page__apple-store-link'>
                        <img src={appleStoreImage} alt={appleLinkHelpText} width='200' />
                      </a>
                      <a className='appLink' href={androidLink} target='_blank' rel='noreferrer' data-testid='member-page__android-store-link'>
                        <img src={androidStoreImage} alt={androidLinkHelpText} width='200' />
                      </a>
                    </div>}
                  <br />
                  <Button data-testid='member-page__sign-out-button' variant='outlined' color='secondary' onClick={() => props.handleLogout()}>Sign Out</Button>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={2} />
          </Grid>
        </Box>
      </BasicFrame>
    )
  }

  return renderDownloadApp()
}

function getPropsFromActions (dispatch) {
  return {
    handleLogout () {
      dispatch(restApi.actions.logout())
    }
  }
}

export default connect(null, getPropsFromActions)(MemberGetAppPage)
